import styled from "styled-components";

export const StyledCloseWSError = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  padding: 20px;
  .link {
    color: #51a5d2;
    text-decoration: underline;
    cursor: pointer;
  }
`;